/*
  popup-placement.js
  Placement des pop-ups en verre de la fiche produit, sans voile sombre ni blocage du
  defilement : la page reste visible, lisible et utilisable autour.
  Utilise par le pop-up "?" (sale-status-popup) et par le pop-up Notify Me
  (section notify-restock).

    Galerie produit visible et assez grande (desktop, et mobile en haut de page) :
      pop-up centre sur la partie visible de la galerie, sans couvrir les infos
      (titre, prix, tailles, carte, boutons).
    Sinon (mobile, page defilee) : carte compacte en bas de l'ecran, au-dessus de la
      barre d'achat collante (si elle est affichee) et du clavier (champs du Notify Me).

  Aucun changement de mise en page a l'ouverture ou a la fermeture : le pop-up est en
  position fixe, hors du flux, et la page n'est jamais verrouillee.

  API :
    NocloutPopupPlacement.open(root)   a appeler apres avoir affiche le pop-up
    NocloutPopupPlacement.close(root)  a appeler a la fermeture
  Le conteneur `root` porte l'attribut data-floating-popup ; sa carte, data-floating-card.
*/
(function () {
  'use strict';
  if (window.NocloutPopupPlacement) return;

  var DESKTOP = '(min-width: 990px)';
  var MARGIN = 16;
  var open = [];

  function visible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function place(root) {
    var vh = window.innerHeight;
    var vw = document.documentElement.clientWidth;
    var style = root.style;
    var card = root.querySelector('[data-floating-card]');
    /* Galerie visible (desktop ou mobile) : le pop-up s'y pose s'il y tient en entier. */
    var media = null;
    document.querySelectorAll('[data-product-desktop-media], [data-product-mobile-media]').forEach(function (m) {
      if (!media && visible(m)) media = m;
    });
    var need = card ? card.scrollHeight + MARGIN * 2 : 240;
    if (window.matchMedia(DESKTOP).matches) need = Math.min(need, 240);

    if (media) {
      var r = media.getBoundingClientRect();
      var top = Math.max(r.top, 0);
      var bottom = Math.min(r.bottom, vh);
      if (bottom - top >= need) {
        root.setAttribute('data-placement', 'media');
        style.left = Math.round(r.left) + 'px';
        style.width = Math.round(r.width) + 'px';
        style.top = Math.round(top) + 'px';
        style.height = Math.round(bottom - top) + 'px';
        style.right = 'auto';
        style.bottom = 'auto';
        style.setProperty('--floating-max-height', Math.round(bottom - top - MARGIN * 2) + 'px');
        return;
      }
    }

    /* Mobile, page defilee : carte compacte dans la moitie de l'ecran opposee au bouton
       qui a ouvert le pop-up, pour que ce bouton (et la carte de statut) restent visibles.
       Bouton dans la moitie basse (ex. "Me prevenir") : en haut, sous l'en-tete.
       Sinon (ex. "?" de la carte, ouverture automatique) : en bas. */
    var trigger = root.__floatingTrigger;
    if (trigger && document.contains(trigger)) {
      var tr = trigger.getBoundingClientRect();
      if (tr.height && tr.top + tr.height / 2 > vh / 2) {
        var headerBottom = 0;
        var header = document.querySelector('header-component, .header');
        if (visible(header)) {
          var hr = header.getBoundingClientRect();
          if (hr.bottom > 0 && hr.top <= 0 + 1) headerBottom = hr.bottom;
        }
        var topOffset = Math.max(0, Math.round(headerBottom)) + 12;
        root.setAttribute('data-placement', 'top');
        style.left = '0px';
        style.width = vw + 'px';
        style.top = topOffset + 'px';
        style.right = 'auto';
        style.bottom = 'auto';
        style.height = 'auto';
        style.setProperty('--floating-max-height', Math.max(200, Math.round(Math.min(tr.top - topOffset - 12, vh - topOffset - MARGIN))) + 'px');
        return;
      }
    }

    /* En bas, au-dessus de la barre collante et du clavier. */
    var offset = 0;
    var sticky = document.querySelector('.product-form__mobile-sticky-button');
    if (visible(sticky)) {
      var sr = sticky.getBoundingClientRect();
      if (sr.top < vh && sr.bottom > 0) offset = Math.max(0, vh - sr.top);
    }
    var vv = window.visualViewport;
    if (vv) offset += Math.max(0, vh - (vv.height + vv.offsetTop));

    root.setAttribute('data-placement', 'bottom');
    style.left = '0px';
    style.width = vw + 'px';
    style.top = 'auto';
    style.right = 'auto';
    style.bottom = Math.round(offset) + 'px';
    style.height = 'auto';
    style.setProperty('--floating-max-height', Math.max(200, Math.round(vh - offset - MARGIN * 2)) + 'px');
  }

  var pending = false;
  function refresh() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      open.forEach(place);
    }, 0);
  }

  function listen(on) {
    var m = on ? 'addEventListener' : 'removeEventListener';
    window[m]('scroll', refresh, { passive: true });
    window[m]('resize', refresh);
    if (window.visualViewport) {
      window.visualViewport[m]('resize', refresh);
      window.visualViewport[m]('scroll', refresh);
    }
  }

  /* Dernier element clique : sert a savoir quel bouton a ouvert le pop-up. */
  var lastClick = { el: null, at: 0 };
  document.addEventListener('click', function (e) {
    /* Les clics dans un pop-up (ex. preselection de la taille par le Notify Me a son
       ouverture) ne comptent pas comme declencheur. */
    if (e.target.closest && e.target.closest('[data-floating-popup]')) return;
    lastClick = { el: e.target, at: Date.now() };
  }, true);

  window.NocloutPopupPlacement = {
    open: function (root) {
      if (!root) return;
      root.__floatingTrigger = Date.now() - lastClick.at < 1000 ? lastClick.el : null;
      if (open.indexOf(root) === -1) open.push(root);
      if (open.length === 1) listen(true);
      place(root);
    },
    close: function (root) {
      var i = open.indexOf(root);
      if (i > -1) open.splice(i, 1);
      if (!open.length) listen(false);
    },
  };

  /* Pop-up deja ouvert avant le chargement de ce fichier (ex. confirmation Notify Me
     apres rechargement de la page) : on le place maintenant. */
  document.querySelectorAll('[data-floating-popup]').forEach(function (root) {
    var shown = root.classList.contains('is-open') || (root.hasAttribute('hidden') === false && root.hasAttribute('data-ss-popup'));
    if (shown && visible(root.querySelector('[data-floating-card]'))) window.NocloutPopupPlacement.open(root);
  });
})();
